import React, {useEffect, useRef} from 'react';
import {Controller, Control} from 'react-hook-form';
import Select from '../select/select';

export interface VuonConcertWard {
    value: number;
    label: string;
}

// Hook function type để inject từ bên ngoài
export type UseWardsHook = (regionId: number) => {
  data?: Array<{
    id: number;
    name: string;
  }>;
};

interface VuonConcertWardSelectControlProps {
    control: Control<any>;
    name: string;
    regionId: number;
    label?: string;
    require?: boolean;
    clearValue?: () => void;
    value: VuonConcertWard | null;
    onChange: (ward: VuonConcertWard) => void;
    placeholder?: string;
    disabled?: boolean;
    useWardsHook: UseWardsHook; // Required dependency
}

export const VuonConcertWardSelectControl: React.FC<VuonConcertWardSelectControlProps> = ({
    control,
    name,
    regionId,
    label,
    require,
    value,
    onChange,
    placeholder,
    disabled,
    useWardsHook, // Inject hook từ bên ngoài
}) => {
    const {data} = useWardsHook(regionId); // Sử dụng hook được inject
    const [wardValue, setWardValue] = React.useState<VuonConcertWard | null>();
    const prevRegionIdRef = useRef<number | undefined>(undefined);

    const wards = data?.map(item => {
        return {
            value: item?.id || 0,
            label: item?.name || '',
        };
    });

    // locale sort
    wards?.sort((a, b) => a.label.localeCompare(b.label));

    useEffect(() => {
        // Chỉ set wardValue khi có value hợp lệ (value > 0)
        const validWard = value?.value && value.value > 0 ? value : null;
        setWardValue(validWard);
    }, [value]);

    // Reset ward khi regionId thay đổi (khi region thay đổi)
    useEffect(() => {
        // Chỉ reset khi regionId thực sự thay đổi, không phải lần đầu render
        if (prevRegionIdRef.current !== undefined && prevRegionIdRef.current !== regionId) {
            const resetWard = {
                value: 0,
                label: '',
            };
            setWardValue(null); // Set UI value to null để clear select
            onChange(resetWard); // Trigger form field change
        }
        prevRegionIdRef.current = regionId;
    }, [regionId, onChange]);

    return (
        <div className={'w-full'}>
            <Controller
                name={name}
                control={control}
                render={({field}) => (
                    <Select
                        {...field}
                        onSelectionChange={e => {
                            field.onChange(e);
                            onChange(e);
                            setWardValue(e);
                        }}
                        label={label}
                        placeHolder={placeholder ?? 'Phường/xã'}
                        options={wards ?? []}
                        value={wardValue}
                        classNameLabel="font-montserrat text-white text-[12px] md:text-[18px] font-bold"
                        className="font-montserrat"
                        isDisable={regionId == 0 || disabled}
                    />
                )}
            />
        </div>
    );
};
